export default "__VITE_ASSET__BpakWHxy__"